import { connect } from 'react-redux';
import getRandom from '../../util/getRandom';

import Course from './course';
import {
  onLoadCourses,
  onLoadCourse,
  onCardSwiped,
  onRestart,
  onFinishRun,
  onRetry,
  onOpenCompletedDialog,
  onExportContent,
  pinOrUnpinContentAction,
  onLoadCard
} from '../../reducers/course.reducers';

import {
  selectTest,
  onStartTest,
  onSetActiveTestRun,
} from '../../reducers/test.reducers';

const mapStateToProps = state => ({
  isLoading: state.courses.isLoadingCards,
  course: state.courses.selectedCourse,
  cards: state.courses.currentCards,
  completedDialogOpen: state.courses.completedDialogOpen,
  courses: state.courses.previewCourses,
  tests: state.tests.tests,
  courseRunStartedAt: state.courses.courseRunStartedAt,
  config: state.authentication.config,
  bulletinBoard: state.courses.bulletinBoard,
  unknownCardsAvailable: state.courses.cardsNotKnown.length > 0,
  testRuns: state.tests.testRuns,
  currentCard: state.courses.cardForModal,
});

const mapDispatchToProps = dispatch => ({
  loadCourse: (course) => {
    dispatch(onLoadCourse(course));
  },
  startNewTestRun: (test) => {
    dispatch(selectTest(test));
    dispatch(onStartTest({ testId: test.id }));
  },
  loadTest: test => dispatch(selectTest(test)),
  setTestRun: run => dispatch(onSetActiveTestRun(run)),
  onLoadCourses: () => dispatch(onLoadCourses()),
  onExportContent: url => dispatch(onExportContent(url)),
  onCardSwiped: (type, card) => dispatch(onCardSwiped({ type, card })),
  onRestart: () => dispatch(onRestart()),
  loadCard: (id) => dispatch(onLoadCard(id)),
  onFinishRun: () => {
    dispatch(onFinishRun());
    dispatch(onOpenCompletedDialog());
  },
  onRetry: () => dispatch(onRetry()),
  pinOrUnpinContent: (bulletinBoardId, pinningDto) => dispatch(pinOrUnpinContentAction({ bulletinBoardId, pinningDto })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Course);



// WEBPACK FOOTER //
// ./src/app/main/course/course.container.js